import { Stack, router } from "expo-router";
import { Platform, Pressable } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { ThemedText } from "@/components/ThemedText";
import { MaterialIcons } from "@expo/vector-icons";
import * as Haptics from "expo-haptics";

function InjuryBackButton() {
  const { colors } = useTheme();

  const handleBack = () => {
    if (Platform.OS !== "web") {
      Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
    }
    router.dismiss();
  };

  return (
    <Pressable
      onPress={handleBack}
      style={({ pressed }) => ({
        flexDirection: "row",
        alignItems: "center",
        opacity: pressed ? 0.7 : 1,
        minWidth: 60,
      })}
    >
      <MaterialIcons color={colors.primary} size={24} name="chevron-left" />
      <ThemedText
        style={{
          color: colors.primary,
          fontSize: 17,
          fontWeight: "400",
          marginLeft: 2,
        }}
      >
        Back
      </ThemedText>
    </Pressable>
  );
}

export default function InjuryLayout() {
  const { colors } = useTheme();

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerShadowVisible: false,
        headerStyle: {
          backgroundColor: colors.backgroundSecondary,
        },
        headerTitleStyle: {
          color: colors.text,
          fontWeight: "600",
          fontSize: 18,
        },
        headerTitleAlign: "center",
        contentStyle: {
          backgroundColor: colors.backgroundSecondary,
        },
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          headerTitle: "Injury Report",
          headerLeft: () => <InjuryBackButton />,
        }}
      />
    </Stack>
  );
}
